import React from 'react';
import { ArticleLayout } from '../../components/ArticleLayout';

export const ExcelTradosArticle: React.FC = () => {
    return (
        <ArticleLayout
            title="Optimizing the Excel to RWS Trados Studio Workflow"
            subtitle="How to prepare Excel files for Trados to maximize leverage and quality."
        >
            <h3>Trados and Excel</h3>
            <p>
                RWS Trados Studio has a built-in Excel filter, but it can be rigid. It often struggles with:
            </p>
            <ul>
                <li>Complex multi-column layouts.</li>
                <li>Embedded HTML content within cells.</li>
                <li>Excluding specific rows based on color or hidden status.</li>
            </ul>

            <h3>The Pre-Processing Advantage</h3>
            <p>
                By converting your Excel to XLIFF 2.0 before importing into Trados, you bypass the limitations of the native Excel filter.
                You gain full control over segmentation (using SRX rules) and can ensure that HTML tags are properly protected as "tags"
                rather than editable text.
            </p>

            <h3>Step-by-Step Workflow</h3>
            <ol>
                <li><strong>Upload to Converter:</strong> Select your Excel file and map your columns.</li>
                <li><strong>Convert to XLIFF:</strong> Download the .xlf file.</li>
                <li><strong>Translate in Trados:</strong> Open the .xlf file in Trados. It will be recognized immediately as a standard XLIFF.</li>
                <li><strong>Export Target:</strong> Save the translated .xlf file from Trados.</li>
                <li><strong>Merge:</strong> Upload the translated .xlf and your original Excel back to the converter to generate the final file.</li>
            </ol>
        </ArticleLayout>
    );
};
